import React from 'react'
import { Link } from 'react-router-dom'

export const ContactInfo = () => {
    const BASE_URL = process.env.PUBLIC_URL;


    return (
        <article className='flex flex-row justify-between	items-center sm:flex-col md:flex-col'>
            <div className='flex flex-col justify-center items-center w-1/4 m-auto sm:w-3/5 mt-20 md:w-4/5 2xl:w-2/5 2xl:ml-0'>
                <h4 className='text-4xl	sm:text-2xl'>Descargar CV</h4>
                <a href={'/assets/cv/CV Andrés Pujol.pdf'} download className='2xl:w-2/5 md:w-4/12 flex justify-center'>
                    <img src={`${BASE_URL}/assets/cv/cv.png`}alt="CV de Andrés Pujol" className='w-3/6' />
                </a>
            </div>
            <div className='flex flex-col justify-between items-center mt-20 lg:w-3/5 xl:w-3/5'>
                <div>
                    <h2 className='text-4xl	sm:text-2xl'>Hablemos!</h2>
                </div>
                <div className='flex justify-around	items-center'>
                    <Link 
                        to='https://www.linkedin.com/in/andrespujol/' 
                        rel="noopener noreferrer"
                        target="_blank" 
                        className=" flex justify-self-center self-center w-2/12  md:w-1/12 2xl:w-1/12"
                        >
                        <img 
                            className='w-3/6 sm:w-4/6 '
                            src={`${BASE_URL}/assets/images/linkedin.png`} 
                            alt ='Logo Linkedin'/>
                    </Link>
                    <Link 
                        to='https://wa.me/+5491156571151' 
                        rel="noopener noreferrer"
                        target="_blank" 
                        className=" flex justify-self-center self-center w-2/12 md:w-1/12 2xl:w-1/12"
                        >
                        <img 
                            className='w-3/6 sm:w-4/6 '
                            src={`${BASE_URL}/assets/images/whatsapp.png`} 
                            alt ='Logo whatsapp'
                            />
                    </Link>
                    <a 
                        href="mailto:andrespujol@gmail.com" 
                        rel="noopener noreferrer"
                        target="_blank" 
                        className=" flex justify-self-center self-center w-2/12 md:w-1/12 2xl:w-1/12"
                        >
                        <img 
                            className='w-3/6 sm:w-4/6 '
                            src={`${BASE_URL}/assets/images/mail.png`} 
                            alt ='Logo mail'/>        
                    </a>
                    </div>
            </div>
        </article>
    )
}
